import { bindCountedSelect } from './counted_select'
import { bindMunicipalitySelect } from './municipality_select'

document.querySelectorAll('[data-reform-case-search-form]').forEach((form) => {
  bindMunicipalitySelect(form)
  const prefecture = form.querySelector('[data-prefecture-select]')
  const municipality = form.querySelector('[data-municipality-select]')
  const initialMunicipality = municipality?.value || ''
  const refreshCountedSelects = Array.from(form.querySelectorAll('[data-counted-select]'))
    .map(bindCountedSelect)
  form.addEventListener('change', () => refreshCountedSelects.forEach((refresh) => refresh()))
  window.addEventListener('pageshow', () => {
    form.reset()
    if (prefecture && municipality) {
      prefecture.dispatchEvent(new Event('change', { bubbles: true }))
      municipality.value = initialMunicipality
    }
    refreshCountedSelects.forEach((refresh) => refresh())
  })
})
